<template>
    <div>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'活动沙龙'},{name:'活动列表'}]" :title="'活动沙龙列表'"/> -->
            <!-- 查询条件 -->
            <div class="retrieve border" ref="condition">
                <div class="left">
                    <div class="child">
                        <span class="name">上架状态</span>
                        <el-select v-model="sendInfo.status" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">活动类型</span>
                        <el-select v-model="sendInfo.activityType" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in activeType"
                            :key="item.id"
                            :label="item.dictName"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">活动状态</span>
                        <el-select v-model="sendInfo.activityStatus" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in activeStatus"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">发布日期</span>
                        <el-date-picker
                         size="small"
						v-model="sendInfoOne.time"
                         format="yyyy-MM-dd"
						value-format="yyyy-MM-dd HH:mm:ss"
						type="datetimerange"
						:default-time="['24:00:00','23:59:59']"
                         range-separator="至"
                         start-placeholder="开始日期"
                         end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    <div class="child super_select">
                        <span class="name">检索</span>
                        <el-select v-model="sendInfoOne.drop" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="sendInfoOne.dropValue" placeholder="请输入" size="small" clearable></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="retrieval" class="retrievalBtn">查询</el-button>
                    <el-button  size="small" @click="onReset" class="retrievalBtn">重置</el-button>
                </div>
                <div class="right">
                    <el-button type="primary" size="small" @click="edit" icon="el-icon-plus"
                               v-if="authorities.indexOf('sys:permission:background:activity:salon:list:button:release')!=-1">发布活动</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <el-table
                :data="tableData"
                :default-sort="{prop: 'date'}"
                @sort-change="sortChange"
                ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="活动ID">
                </el-table-column>
                <el-table-column
                    prop="activityTypeValue"
                    show-overflow-tooltip
                    
                    label="活动类型">
                </el-table-column>
                <el-table-column
                    prop="activityTitle"
                    show-overflow-tooltip
                    
                    width="300"
                    label="活动标题">
                </el-table-column>
                <el-table-column
                    prop="activityStatusValue"
                    show-overflow-tooltip
                    
                    label="活动状态">
                </el-table-column>
                <el-table-column
                    prop="statusValue"
                    show-overflow-tooltip
                    
                    label="上架状态">
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    
                    label="发布账号">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    sortable
                    width="150"
                    label="发布时间">
                </el-table-column>
                <el-table-column
                    prop="modifyUserName"
                    show-overflow-tooltip
                    
                    label="更新账号">
                </el-table-column>
                <el-table-column
                    prop="updateTime"
                    show-overflow-tooltip
                    
                    sortable
                    width="150"
                    label="更新时间">
                </el-table-column>
                <el-table-column prop="views" sortable="custom" show-overflow-tooltip  width="100" label="浏览数"></el-table-column>

                <el-table-column
                    v-if="authorities.indexOf('sys:permission:background:activity:salon:list:button:view')!=-1 ||
                    authorities.indexOf('sys:permission:background:activity:salon:list:button:edit')!=-1 ||
                    authorities.indexOf('sys:permission:background:activity:salon:list:button:status')!=-1"
                    label="操作"
                    
                    width="300">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain v-if="authorities.indexOf('sys:permission:background:activity:salon:list:button:view')!=-1" @click="check(scope.row)">查看</el-button>
                        <el-button :class="{'noclick':scope.row.isEditable==1||scope.row.status==1}"  size="small" type="primary" class="super" plain @click="edit(scope.row)"
                                   v-if="authorities.indexOf('sys:permission:background:activity:salon:list:button:edit')!=-1">编辑</el-button>
                        <el-button :class="{'noclick':scope.row.isEditable==1}"  size="small" :type="scope.row.btnValue ==='上架'?'success':'warning'" class="super" plain @click="soldOut(scope.row)"
                                   v-if="authorities.indexOf('sys:permission:background:activity:salon:list:button:status')!=-1">{{scope.row.btnValue}}</el-button>
                        <el-button size="small" type="primary" class="super" plain v-if="scope.row.activityStatus === 2" @click="onUpload(scope.row)">上传回顾</el-button></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref="pagination">
                <Paging
                :PageData="PageData"
                @nextpage="nextpage"
                @previouspage="previouspage"
                @handleSizeChange="handleSizeChange"
                @handleCurrentChange="handleCurrentChange"
                ></Paging>
            </div>
        </div>
        <el-dialog
            title="上传精彩回顾"
            :visible.sync="dialogVisible"
            width="32%" >
            <div v-loading="upLoading"
                element-loading-text="请求中......">  <upLoad
						:action="'backstage/annex/files'"
						:accept="'image/png,image/jpg,image/jpeg'" 
						:size="20"
            is-need-limit
            :limit="8"
            is-multiple
            :sizeList="[1 / 1]"
            :fixedNumber='[1,1]'
            :autoCropWidth="200"
            :autoCropHeight='200'
						v-model="hgForm.photoList" tip="图片仅支持png、jpg,最多上传8张，建议高宽比为1:1，尺寸建议200*200px，大小不超过20M（多文件上传不支持图片裁剪，请按建议上传）"/> 
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button size="small" @click="onClose">取 消</el-button>
              <el-button size="small" type="primary" @click="onSub">确 定</el-button>
            </span>
          </el-dialog>
    </div>
</template>

<script>
// import breadcrumb from '../../components/breadcrumb';
import Paging from '../../components/Paging';
import {getDict} from "@/axios";
import upLoad from '../../components/upLoads'
export default {
    components:{
        // breadcrumb,
        Paging,
        upLoad
    },
    data(){
        return{
          upLoading:false,
          dialogVisible:false,
            loading:false,
            bHeight: void 0,
            authorities:JSON.parse(window.localStorage.getItem('authorities')),
			statusList:[],
			activeStatus:[],//活动状态
			activeType:[],//活动类型
            options: [{
                value: '2',
                label: '活动标题'
                }, {
                value: '3',
                label: '发布账号'
            }, {
                value: '4',
                label: '更新账号'
            }],//检索下拉
            sendInfoOne:{
                time:"",//发布日期
                drop:'',//检索选择值
                dropValue:'',//检索输入值
            },//检索提交数据
            sendInfo:{
            	currentPage:1,//当前页
            	pageSize:10,//页条数
            	property:null,//排序字段
            	direction: 'DESC', //排序排序方式DESC降 ASC升
            	endDate:null,//结束时间
            	startDate:null,//开始时间
            	id:null,//资讯ID
            	status:null,//上架状态
            	name:null,//姓名
            	userName:null,//账号
				updateUserName:null,//更新账号
				activityType:'',//活动类型
				activityTitle:'',//活动标题
				activityStatus:'',//活动状态
            },
			PageData:{
			  currentPage: 0,
			  total: 0, //多少條
			},
			dataInfo:'',//详细信息
			tableData:[],//表格数据
      hgForm:{
          photoList: [],
          salonId: void 0
        }
        }
    },
	created() {
		// 上下架状态
		getDict('UA_LS').then(data=>{
		    this.statusList = data.UA_LS;
		})
		// 活动状态 ACTIVITY_STATUS
		getDict('ACTIVITY_STATUS').then(data=>{
		    this.activeStatus = data.ACTIVITY_STATUS;
		})
		// 活动类型
		this.$axiosz.get('/rpc/sysDict/parentId/1069409892302848').then(res=>{
		    if(res.code==200){
				this.activeType=res.data
		    }else{
		        this.$alert(res.msg)
		    }
		})
		this.getList();
	},
  mounted(){
    const that = this
    let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 25
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 25
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
  },
    methods:{
      onClose(){
        this.upLoading = false
        this.dialogVisible = false
      },
      async onSub(){
        if(!this.hgForm.photoList && this.hgForm.photoList.length === 0){
          this.$message.info('请上传精彩回顾')
          return 
        }
        const {code ,msg} = await this.$axioscBody.post('/backstage/activity/salon/BannerSave',this.hgForm)
        if(code === 200) {
          this.hgForm={
            id: void 0,
            photoList:[]
          }
          this.dialogVisible = false
          this.$message.success('保存成功')
        }else{
          this.$message.info(msg ||'保存失败')
        }
      },
      onUpload(row){
        this.hgForm.salonId = row.id
        this.hgForm.photoList = []
        this.dialogVisible = true
        this.getHg(row.id)
      },
      async getHg(id){
        try{
        this.upLoading = true
        const {code,data,msg} = await this.$axiosc.get(`/backstage/activity/salon/reviewLog/banner/${id}`)
        if(code === 200){
            const items = data && data.length !== 0?data.map((item, i) => ({
              fileName:item.fileName,
              filePath:item.filePath
          })) : []
            
            this.hgForm.photoList = items
            this.upLoading = false
        }
        }catch(e){
          this.upLoading = false
        }
      },
      onReset(){
        const params = {
          currentPage:1,//当前页
            	pageSize:10,//页条数
            	property:null,//排序字段
            	direction: 'DESC', //排序排序方式DESC降 ASC升
            	endDate:null,//结束时间
            	startDate:null,//开始时间
            	id:null,//资讯ID
            	status:null,//上架状态
            	name:null,//姓名
            	userName:null,//账号
				updateUserName:null,//更新账号
				activityType:'',//活动类型
				activityTitle:'',//活动标题
				activityStatus:'',//活动状态
        }
        this.sendInfo = Object.assign(this.sendInfo,params)
        const aa = {
          time:"",//发布日期
          drop:'',//检索选择值
          dropValue:'',//检索输入值
        }
        this.sendInfoOne = Object.assign(this.sendInfoOne,aa)
        if(this.$refs.table) this.$refs.table.clearSort()
        this.retrieval()
      },
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
		getList(){
      this.loading = true
			this.$axiosc.get('/backstage/activity/salon/all/list',{params:this.sendInfo}).then(res=>{
          this.loading = false
			    if(res.code==200){
			        this.tableData=res.data.content;
			        this.PageData.currentPage =res.data.currentPage; //当前页
			        this.PageData.total =res.data.totalElements;
			    }else{
			        this.$alert(res.msg)
			    }
			}).catch(e=>{
        this.loading = false
      })
		},
        //查询
        retrieval:function(){
			let lookData=this.sendInfoOne;
			if(lookData.time&&lookData.time.length>0){
				this.sendInfo.startDate=lookData.time[0];
				this.sendInfo.endDate=lookData.time[1];
			}else {
                this.sendInfo.startDate=null;
                this.sendInfo.endDate=null;
            }
			// 检索值
			let lookdell=lookData.drop;
			if(lookdell==1){
				this.sendInfo.id=lookData.dropValue;
				this.sendInfo.userName=null;
				this.sendInfo.updateUserName=null;
				this.sendInfo.activityTitle=null;
			}else if(lookdell==2){
				this.sendInfo.activityTitle=lookData.dropValue;
				this.sendInfo.id=null;
				this.sendInfo.updateUserName=null;
				this.sendInfo.userName=null;
			}else if(lookdell==3){
				this.sendInfo.userName=lookData.dropValue;
				this.sendInfo.activityTitle=null;
				this.sendInfo.id=null;
				this.sendInfo.updateUserName=null;
			}else if(lookdell==4){
				this.sendInfo.updateUserName=lookData.dropValue;
				this.sendInfo.activityTitle=null;
				this.sendInfo.id=null;
				this.sendInfo.userName=null;
			}
			this.getList()
		},
        //表格排序
        sortChange:function({ column, prop, order }){
            if(order=='ascending'){
                order='ASC';
            }else{
                order='DESC';
            }
            this.sendInfo.property=prop;
            this.sendInfo.direction=order;
            this.getList()
        },
        //表格查看按钮
        check:function(row){
            this.$router.push({path:'/salonManagement/detail',query:{id:row.id,index:'/salonManagement'}})
        },
        //发布 编辑
        edit:function(row){
            if(row){//编辑
			if(row.isEditable==1||row.status==1){
				return
			}
             this.$router.push({path:'/salonManagement/edit',query:{id:row.id,index:'/salonManagement'}})
            }else{//发布
                this.$router.push({path:'/salonManagement/add',query:{index:'/salonManagement'}})
            }
        },
        //表格下架,上架按钮
        soldOut:function(row){
			if(row.isEditable==1){
				return
			}
			let btnValue=row.btnValue;
            this.$confirm(`确认${btnValue}？`, btnValue, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$axiosc.put('/backstage/activity/shelf/obtained/'+row.id).then((r)=>{
                        if(r.code==200){
                            this.$message({
                                type: 'success',
                                message: btnValue+'成功!'
                            });
                            this.getList();
                        }else{
                            this.$alert(r.msg);
                        }
                    })
                }).catch(() => {
            });
        },
        // 下一頁
        nextpage(val) {
          this.sendInfo.currentPage=val;
          this.getList();
        },
        // 上一頁
        previouspage(val) {
          this.sendInfo.currentPage=val;
          this.getList();
        },
        handleSizeChange(val) {
          this.sendInfo.pageSize = val;
          this.getList()
        },
        handleCurrentChange(val) {
          this.sendInfo.currentPage = val;
          this.getList()
        },
    },watch:{
		'sendInfoOne.drop': {
        handler(val, oldVal) {
         this.sendInfoOne.dropValue=''
        },
        deep: true
      }
	}
}
</script>
<style scoped="scoped">
	.noclick{
		color: #DDDDDD;
		border: 1px solid #ddd;
	}
</style>
